// logging.js - Centralized logging utility
const DEBUG = true; // Set to true for development, false for production
export function log(...args) {
  if (DEBUG) {
    console.log(...args);
  }
}
